<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key"/>
      </keep-alive>
    </transition>
    <!-- <el-link style="text-align: center;line-height: 30px;width:100%;" href="http://beian.miit.gov.cn/" target="_blank">© 2009-2019 wansans.com 版权所有 浙ICP备16030843号-2</el-link> -->
  </section>
</template>

<script>
import Vue from 'vue'
import { CySocket } from '../../../../static/CySocket.js'
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.fullPath
    }
  },
  mounted() {
    console.log(process.env.WS_API, '26----------')
    this.formatdate()
    this.creatsocket()
  },
  methods: {
    // 实例化socket
    creatsocket() {
      const that = this
      const loginNo = this.$store.getters.roles.LogNo
      // console.log(loginNo)
      Vue.prototype.cySocket = new CySocket({
        server: process.env.WS_API,
        autoReconnect: false,
        openSocket: function() {
          const user = new window.proto.SocketCmd.CmdHeader()
          user.setCmdcode(0X0202) // 命令号
          user.setIdentity(loginNo) // 客户端标识
          user.setTimetoken(new Date().getTime()) // 命令时间
          this.sendMsg(user.serializeBinary())
        },
        receiveMsg: function(data) {
          const commBk = window.proto.SocketCmd.CmdHeader.deserializeBinary(data)
          console.log(commBk)
          switch (commBk.getCmdcode()) {
            case 0X0202: // 客户端登录
              // console.log(commBk)
              break
            case 0X0205: // 开柜子
              console.log(commBk.getResultcode())

              break
            case 0X0105:
              console.log('1')
              console.log(commBk)
              if (commBk.getResultcode() === 1) {
                that.$message.success('箱子已打开，使用完毕请关上箱门~')
              }
              break
            case 0X0207: // 修改箱子价格
              console.log(commBk)
              break
          }
        }
      })
      Vue.prototype.cySocket.init()
    },
    formatdate() {
      window.Date.prototype.format = window.Date.prototype.format || function(fmt) {
        var o = {
          'M+': this.getMonth() + 1, // 月份
          'd+': this.getDate(), // 日
          'h+': this.getHours(), // 小时
          'm+': this.getMinutes(), // 分
          's+': this.getSeconds(), // 秒
          'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
          'f': this.getMilliseconds() // 毫秒
        }
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
        return fmt
      }
    }
  }
}
</script>

<style scoped>
.app-main {
  /*84 = navbar + tags-view = 50 +34 */
  min-height: calc(100vh - 84px);
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #F5F5F5;
}
</style>

